export const MessageInitialState = {
  isNewMessage: false
};

export interface MessageInitialStateType {
  isNewMessage: boolean;
}
